<template>
  <v-dialog
    v-model="isActive"
    max-width="35rem"
    @click:outside="cancelDialog"
    @keydown.esc="cancelDialog"
    class="ticket-view-modal">
    <v-card class="ticket-view-card" color="white-grey darken-1" :loading="isUpdating">
      <div style="display: flex; justify-content: center">
        <v-card-title color="primary" class="text-h5 font-weight-black"
          >{{ $t('admin.commands.send_new_command').toUpperCase() }}
        </v-card-title>
      </div>
      <v-form>
        <v-container>
          <v-row align="center" dense>
            <!-- SELECT COMANDO -->
            <v-col cols="6">
              <v-select
                v-model="selectedCommand"
                dense
                hide-details
                chips
                single-line
                :items="commandList"
                item-text="name"
                item-value="value"
                :label="$t('admin.commands.select_command')">
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0" small class="ma-0">
                    {{ item.name }}
                  </v-chip>
                </template>
              </v-select>
            </v-col>

            <!-- AUTOCOMPLETE DISPOSITIVOS -->
            <v-col cols="6">
              <v-autocomplete
                v-model="devicesModel"
                multiple
                dense
                chips
                single-line
                hide-details
                :items="devicesForSelect"
                :label="$t('admin_menu.devices')">
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0" small class="ma-0">
                    {{ item.text ?? item }}
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption ml-2"> (+{{ devicesModel.length - 1 }} others) </span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <!-- ** TEXTFIELD CIF -->
          <v-col :cols="!isMobile ? 12 : 12" v-if="selectedCommand?.toLowerCase() === cmdCif.toLowerCase()">
            <v-text-field
              :dark="theme === 'dark'"
              dense
              v-model="cif"
              :disabled="isUpdating"
              color="blue-grey lighten-2"
              :label="$t('admin.commands.cif')" />
          </v-col>

          <!-- ** TEXTFIELD ALIAS -->
          <v-col :cols="!isMobile ? 12 : 12" v-if="selectedCommand?.toLowerCase() === cmdAlias.toLowerCase()">
            <v-text-field
              :dark="theme === 'dark'"
              dense
              v-model="alias"
              :disabled="isUpdating"
              color="blue-grey lighten-2"
              :label="$t('admin.commands.alias')"
              :rules="maxAliasLengthRule" />
          </v-col>

          <!-- ** TEXTFIELD SETPOINT -->
          <v-col :cols="!isMobile ? 12 : 12" v-if="selectedCommand?.toLowerCase() === cmdSetPoint.toLowerCase()">
            <v-text-field
              :dark="theme === 'dark'"
              dense
              type="number"
              v-model="setpoint"
              :disabled="isUpdating"
              color="blue-grey lighten-2"
              :label="$t('admin.commands.setpoint')" />
          </v-col>

          <!-- ** V-SELECT PERIOD -->
          <v-col :cols="!isMobile ? 12 : 12" v-if="selectedCommand?.toLowerCase() === cmdPeriod.toLowerCase()">
            <v-text-field
              :dark="theme === 'dark'"
              dense
              type="number"
              v-model="storagePeriod"
              :disabled="isUpdating"
              color="blue-grey lighten-2"
              :rules="periodRules"
              :label="$t('admin.commands.storage_period')" />
          </v-col>
        </v-container>
      </v-form>

      <v-card-actions>
        <v-row>
          <v-col cols="6" class="text-md-center" :style="isMobile ? 'display: flex; justify-content: center' : ''">
            <v-btn :loading="isUpdating" small color="red " depressed text @click="cancelDialog">
              <v-icon left>mdi-cancel </v-icon>
              {{ isCreated ? $t('general.form.finish') : $t('general.form.exit') }}
            </v-btn>
          </v-col>
          <v-col cols="6" class="text-md-center" :style="isMobile ? 'display: flex; justify-content: center' : ''">
            <v-btn outlined :disabled="filledButton" small :loading="isUpdating" color="success" depressed @click="saveDialog">
              <v-icon left> mdi-content-save </v-icon>
              {{ $t('admin.commands.send') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="4000">
      {{ text }}
    </v-snackbar>
  </v-dialog>
</template>

<script>
import { getAllDevices } from '../../viewModels/adminViewModel';
import { sentCommand } from '../../viewModels/commandsViewModel';
const ls = require('localstorage-slim');
const VueI18n = require('../../plugins/lang/index');

export default {
  data: () => {
    return {
      snackbar: false,
      snackbarColor: 'default',
      text: '',
      theme: ls.get('theme') ?? 'ligth',
      isActive: false,
      selectedCommand: null,
      devicesModel: [],
      isUpdating: false,
      cif: '',
      alias: '',
      setpoint: '',
      storagePeriod: '',
      devices: [],
      filledButton: true,
      isCreated: false,
      cmdSaveProbes: 'saveProbes',
      cmdAlias: 'plate',
      cmdCif: 'cif',
      cmdVersion: 'version',
      cmdSetPoint: 'setPoint',
      cmdGetProbeRom: 'getProbeRom',
      cmdReboot: 'reboot',
      cmdPeriod: 'period',
      commandList: [
        { name: VueI18n.default.t('admin.commands.memorise_sensors'), value: 'saveProbes' },
        { name: VueI18n.default.t('admin.commands.change_alias'), value: 'plate' },
        { name: VueI18n.default.t('admin.commands.change_cif'), value: 'cif' },
        { name: VueI18n.default.t('admin.commands.software_version'), value: 'version' },
        { name: VueI18n.default.t('admin.commands.change_setpoint'), value: 'setPoint' },
        { name: VueI18n.default.t('admin.commands.probe_sn'), value: 'getProbeRom' },
        { name: VueI18n.default.t('admin.commands.reboot_device'), value: 'reboot' },
        { name: VueI18n.default.t('admin.commands.storage_period'), value: 'period' },
      ],
    };
  },

  methods: {
    cancelDialog: function () {
      this.isActive = false;
    },
    async saveDialog() {
      const email = localStorage.getItem('authEmail');
      const selected = this.selectedCommand.toLowerCase();
      const commandMap = {
        [this.cmdCif.toLowerCase()]: this.cif,
        [this.cmdAlias.toLowerCase()]: this.alias,
        [this.cmdSetPoint.toLowerCase()]: this.setpoint,
        [this.cmdPeriod.toLowerCase()]: this.storagePeriod,
      };

      const param = commandMap[selected];
      const payload = {
        status: 'sent',
        type: this.selectedCommand,
        param1: param,
        param2: null,
        sent: new Date(),
        sentBy: email,
        deviceSn: this.devicesModel,
      };

      await sentCommand(payload);
      this.isCreated = true;
    },
    isMatchCommand() {
      const cmd = this.selectedCommand.toLowerCase();

      return [this.cmdSaveProbes, this.cmdVersion, this.cmdGetProbeRom, this.cmdReboot].some(
        (command) => command.toLowerCase() === cmd,
      );
    },

    setActiveModal: function (active) {
      this.isActive = active;
    },
    checkButtonState() {
      if (this.selectedCommand && this.devicesModel.length > 0) {
        if (this.isMatchCommand()) {
          // SAVE MEMORISE_SENSORS
          this.filledButton = false;
        } else if (this.selectedCommand.toLowerCase() === this.cmdAlias.toLowerCase()) {
          // SAVE ALIAS
          this.alias !== '' && this.maxAliasLengthRule ? (this.filledButton = false) : (this.filledButton = true);
        } else if (this.selectedCommand.toLowerCase() === this.cmdCif.toLowerCase()) {
          // SAVE CIF
          this.cif !== '' ? (this.filledButton = false) : (this.filledButton = true);
        } else if (this.selectedCommand.toLowerCase() === this.cmdSetPoint.toLowerCase()) {
          // SAVE cmdSetPoint
          this.setpoint !== '' && this.setpoint !== null ? (this.filledButton = false) : (this.filledButton = true);
        } else if (this.selectedCommand.toLowerCase() === this.cmdPeriod.toLowerCase()) {
          // SAVE PERIOD
          const isPeriodValid = this.periodRules.every((rule) => rule(this.storagePeriod) === true);
          this.filledButton = !isPeriodValid;
        } else {
          //default
          this.filledButton = true;
        }
      } else {
        this.filledButton = true;
      }
    },
  },

  mounted: async function () {
    this.devices = await getAllDevices();
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },

    devicesForSelect() {
      return this.devices.map((d) => ({
        text: `${d.device_sn}`,
        value: d.device_sn,
      }));
    },
    maxAliasLengthRule() {
      const regex = /^(?!.*[~˜])[a-zA-Z0-9-\s]{1,20}$/;

      return [(value) => regex.test(value) || this.$t('dashboard.configuration.alphabet_character_rule')];
    },
    periodRules() {
      const regex = /^(?!.*[~˜])[a-zA-Z0-9-\s]{1,20}$/;

      return [
        (v) => (v !== null && v !== '') || this.$t('admin.commands.field_required'),
        (v) => Number(v) >= 0 || this.$t('admin.commands.negative_not_allowed'),
        (v) => Number(v) <= 60 || this.$t('admin.commands.maximum_value'),
      ];
    },
  },

  watch: {
    cif() {
      this.checkButtonState();
    },
    alias() {
      this.checkButtonState();
    },
    setpoint() {
      this.checkButtonState();
    },
    devicesModel() {
      this.checkButtonState();
    },
    selectedCommand() {
      this.checkButtonState();
    },
    storagePeriod() {
      this.checkButtonState();
    },
  },
};
</script>
<style></style>
